<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('refunds')"
                        :isNewButton="checkPermission('customerrefund_store')"
                        @new-button-click="createFormShow"
                        :is-import-button="checkPermission('customerrefund_excelimport')"
                        @import-button-click="importData"
                        @filter-div-status="datatable.filterStatus=$event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('refunds')"
                              :isNewButton="checkPermission('customerrefund_store')"
                              @new-button-click="createFormShow"
                              :is-import-button="checkPermission('customerrefund_excelimport')"
                              @import-button-click="importData"
                              @filter-div-status="datatable.filterStatus=$event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear" :exportExcel="checkPermission('customerrefund_excelexport')" @exportExcel="exportExcel">
                <b-row>
                    <b-col sm="4">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                          <b-form-group :label="$t('period')">
                            <payment-periods-selectbox v-model="datatable.queryParams.filter.period_id"></payment-periods-selectbox>
                        </b-form-group>
                    </b-col>
                  <b-col sm="4">
                    <b-form-group :label="$t('currency')">
                      <currency-selectbox v-model="datatable.queryParams.filter.currency" />
                    </b-form-group>
                  </b-col>
                    <b-col sm="4">
                       <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.date_after" />
						          </b-form-group>
                    </b-col>
                  <b-col sm="4">
                    <b-form-group :label="$t('end_date')">
                      <select-date v-model="datatable.queryParams.filter.date_before" />
                    </b-form-group>
                  </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('faculty_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="importFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
				<template v-slot:CommonModalTitle>
					{{ $t('import').toUpper() }}
				</template>
				<template v-slot:CommonModalContent>
					<import-form @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
				</template>
			</CommonModal>
        </app-layout>
    </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
//Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox";
import SelectDate from "@/components/interactive-fields/SelectDate";
//Services
import CustomerRefundService from "@/services/CustomerRefundService";
//Page
import CreateForm from "./CreateForm"
import UpdateForm from "./UpdateForm"
import ShowForm from "./ShowForm"
import ImportForm from "./ImportExcel"

//Other
import qs from 'qs'
import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";

export default {
    components: {
      CurrencySelectbox,
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
        PaymentPeriodsSelectbox,
        SelectDate,

        ShowForm,
        CreateForm,
        UpdateForm,
        ImportForm
    },
    metaInfo() {
        return {
            title: this.$t('refunds')
        }
    },
    data() {
        return {
            id: 0,
            form: {},
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [

                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line',
                                permission: 'customerrefund_show',
                                callback: (row) => {
                                    this.showForm(row.id);
                                },
                            },
                            {
                                text: this.$t('edit'),
                                class: 'ri-edit-box-line',
                                permission: 'customerrefund_update',
                                callback: (row) => {
                                    this.loadData(row.id);
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-2-line',
                                permission: 'customerrefund_delete',
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            },
                        ]
                    },
                    {
                        label: this.$t('student_number'),
                        field: 'number',
                        sortable: true,
                    },
                    {
                        label: this.$t('full_name'),
                        field: 'name',
                        sortable: false,
                        formatFn: (value, row) => {
                            return row.name+' '+row.surname
                        }
                    },
                  {
                    label: this.$t('period'),
                    field: 'period_code',
                    sortable: false,
                  },
                    {
                        label: this.$t('amount'),
                        field: 'amount',
                        sortable: true,
                    },
                    {
                        label: this.$t('currency'),
                        field: 'currency',
                        sortable: false,
                    },
                    {
                        label: this.$t('refund_date'),
                        field: 'date',
                        sortable: true,
                    },
                    {
                        label: this.$t('refund_reason'),
                        field: this.getLocaleField('reason_name'),
                        sortable: false,
                    },
                    {
                        label: this.$t('explanation'),
                        field: 'explanation',
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'date',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId:0
        }
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return CustomerRefundService.getAll(config)
                                .then((response) => {
                                    this.datatable.rows = response.data.data
                                    this.datatable.total = response.data.pagination.total
                                })
                                .finally(() => {
                                    this.datatable.isLoading = false;
                                });
        },
        loadData(id) {
            this.formId = id;
            this.formProcess='update';
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        CustomerRefundService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
        async createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        async updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        // Show
        showForm(id) {
            this.formId = id
            this.formProcess = 'show'
            this.$refs.showModal.$refs.commonModal.show()
        },
        createFormShow() {
            this.formId = null
            this.form = {};
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
		importData() {
			this.formProcess = 'import'
			this.$refs.importFormModal.$refs.commonModal.show()
		},
		importFormSuccess() {
			this.formProcess = null;
			this.$refs.importFormModal.$refs.commonModal.hide()
		},
        exportExcel(){
            const params = {
                ...this.datatable.queryParams,
                sort: 'date'
            };

            const config = {
                params,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return CustomerRefundService.exportExcel(config)
                              .then((response) => {
                                  this._downloadFile(response,this.$t('refunds')+'.xlsx')
                              })
                              .catch(err=>this.showErrors(err))
        }
    }
}
</script>

